<template>
    <div class="reply">
        <img src="@/assets/images/icons/plane.svg" :width="size">
    </div>
</template>
<script>
export default {
    name: 'Reply',
    props: {
        size: {
            type: Number,
            require: false
        }
    }
}
</script>

<style lang="stylus">
.reply
    display flex
    align-items center
    cursor pointer
</style>